module.exports = __webpack_public_path__ + "static/media/sf_1700.b3756ba152a61de431f78837c76e86d8.png";